<div class="atn-ds-table">
  @if (store.containerSg() === 'widget') {
    <atn-ds-widget
      class="atn-ds-table__widget"
      [title]="store.titleSg()"
    >
      <atn-ds-table-toolbar actions>
        <ng-content select="[customTools]" />
      </atn-ds-table-toolbar>
      <atn-ds-table-content />
    </atn-ds-widget>
  } @else {
    <atn-ds-table-content />
  }
</div>
